<template>
  <div class="tab-content" id="nav-tabContent">
    <div class="tab-pane fade" :class="getActiveClass(0)" id="nav-map" role="tabpanel" aria-labelledby="nav-map-tab">
      <search-results-map :searchResults="searchResults" :searchQuery="searchQuery" :tabActive="activeTabIndex === 0"  />
    </div>
    <div class="tab-pane fade" :class="getActiveClass(1)" id="nav-list" role="tabpanel" aria-labelledby="nav-list-tab">
      <search-results-grid :searchResults="gridSearchResults" :searchQuery="searchQuery" :searchFilters="searchFilters" :noSearchResults="noSearchResults" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'SearchTabsContent',

  methods: {
    getActiveClass: function (index) {
      return this.activeTabIndex === index ? 'show active' : ''
    }
  },

  computed: {
    noSearchResults: function () {
      return _.get(this.searchResults, 'matches') === 0
    },
    gridSearchResults: function () {
      const results = {}
      for (const [key, value] of Object.entries(this.searchResults)) {
        if (key !== 'matches') {
          results[key] = {
            ...value,
            result: (this.searchQuery === '' && !this.hasFilters) ? _.take(value.result, 8) : value.result
          }
        } else {
          results[key] = value
        }
      }
      return results
    },
    hasFilters: function () {
      return this.searchFilters && Object.values(this.searchFilters).flat().length > 0
    },
    ...mapGetters({
      indexFromStore: 'activeTabIndex'
    }),
    activeTabIndex: {
      get () {
        return this.indexFromStore
      },
      set (newIndex) {
        return this.$store.dispatch('setActiveTabIndex', newIndex)
      }
    },
    ...mapState({
      searchQuery: state => state.search.searchQuery,
      searchResults: state => state.search.searchResults,
      searchFilters: state => state.search.filtered,
      matchingLocations: state => _.get(state.search.searchResults, 'locations.count') || 0,
      matchingResults: state => state.search.searchResults.matches || 0
    })
  }
}
</script>
